import { render, staticRenderFns } from "./position-form.vue?vue&type=template&id=6c3b7e21&scoped=true&"
import script from "./position-form.vue?vue&type=script&lang=js&"
export * from "./position-form.vue?vue&type=script&lang=js&"
import style0 from "./position-form.vue?vue&type=style&index=0&lang=css&"
import style1 from "./position-form.vue?vue&type=style&index=1&id=6c3b7e21&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3b7e21",
  null
  
)

export default component.exports